module.exports = __webpack_public_path__ + "static/media/pointer-arctic.efb00227.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/pointer-arctic.svg
// module id = 241
// module chunks = 0